import { render, staticRenderFns } from "./ConversionCollection.vue?vue&type=template&id=c5726908&scoped=true"
import script from "./ConversionCollection.vue?vue&type=script&lang=js"
export * from "./ConversionCollection.vue?vue&type=script&lang=js"
import style0 from "./ConversionCollection.vue?vue&type=style&index=0&id=c5726908&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5726908",
  null
  
)

export default component.exports